/* @flow */
import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

export class DatalistInput extends React.Component {
  render() {
    const {
      field,
      children,
      options,
      placeholder,
      isInline,
      ariaLabelledBy,
      ariaDescribedBy,
      qaTag,
      isFormGroup,
      hasHelpText,
      onChange,
      disabled,
      ariaLabel,
    } = this.props;

    const inputClasses = classNames({
      'inline-element': isInline,
      'form-group': isFormGroup,
      'has-error': field.meta.invalid && field.meta.touched,
    });

    let onChangeFunction = field.input.onChange;
    if (onChange) {
      onChangeFunction = (event) => {
        field.input.onChange(event);
        onChange(event);
      };
    }

    const inputAttributes = {
      type: 'text',
      className: 'form-control form-control-ie',
      placeholder,
      id: field.input.name,
      name: field.input.name,
      list: field.input.name + '_list',
      value: field.input.value,
      onChange: onChangeFunction,
      'aria-labelledby': ariaLabelledBy,
      'data-qa-item': qaTag,
      disabled,
      'aria-label': ariaLabel,
    };

    if (hasHelpText) {
      inputAttributes['aria-describedby'] = ariaDescribedBy;
    }

    return (
      <div className={ inputClasses } >
        <input { ...inputAttributes } />
        <datalist id={ field.input.name + '_list' }>
          {options.map(opt =>
            (
              <option value={ opt.value } key={ opt.key }>
                { opt.displayValue }
              </option>
            )
          )}
        </datalist>
        { children }
      </div>
    );
  }
}

DatalistInput.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.object,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  isInline: PropTypes.bool,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  qaTag: PropTypes.string,
  isFormGroup: PropTypes.bool,
  hasHelpText: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};